window.duplicateFormatter = function(value, row) {
    let html = '';
    if (row.allow_duplicate === "0") {
        return html;
    }
    html += '<a href="#" class="action action-duplicate">';
    html += '<i class="fa fa-random"></i>';
    html += '</a>';
    return html;
};
